module.exports = __webpack_public_path__ + "img/payment-methods.a0c751d3.png";